import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const ArrowDown10: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm3 16 4 4 4-4' }],
    ['path', { d: 'M7 20V4' }],
    ['path', { d: 'M17 10V4h-2' }],
    ['path', { d: 'M15 10h4' }],
    ['rect', { x: '15', y: '14', width: '4', height: '6', ry: '2' }],
  ],
];

export default ArrowDown10;
